/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed, set } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import HotelSettingsMyotbMyotbBaseController from 'lumen/controllers/hotel/settings/myotb/myotb-base';
import { STAGES } from 'lumen/utils/constants/otb-selfservice-constants';

export default class HotelSettingsMyotbPmsUnsupportedController extends HotelSettingsMyotbMyotbBaseController {
  @service declare alerting: Services['alerting'];
  @service declare errorTracking: Services['error-tracking'];
  @service declare intl: Services['intl'];
  // eslint-disable-next-line ember/no-unused-services
  @service declare myotbSs: Services['myotb-ss'];
  @service declare toast: Services['toast'];

  @tracked isInterestedInFutureResearch = false;

  pageName = STAGES.PMS_UNSUPPORTED_PAGE;

  saveTask = task(async (enableResearch): Promise<void> => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      set(this.otbSelfService, 'futureResearchCandidate', enableResearch);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      await this.otbSelfService.save();
      this.toast.success(this.intl.t('general.changes_saved').toString(), {
        showIcon: true,
      });
    } catch (error) {
      this.errorTracking.captureException(error);
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.alerting.showErrorAlert();
    }
  });

  signUpForResearchTask = task(async (): Promise<void> => {
    await this.saveTask.perform(true);
  });

  withdrawFromResearchTask = task(async (): Promise<void> => {
    await this.saveTask.perform(false);
  });

  @computed('otbSelfService.futureResearchCandidate')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get futureResearchCandidate() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.otbSelfService?.futureResearchCandidate;
  }

  set futureResearchCandidate(value) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    set(this.otbSelfService, 'futureResearchCandidate', value);
  }
}
